import {
  configureStore,
  createAction,
  combineReducers,
} from "@reduxjs/toolkit";
import userReducer from "./slice/userSlice";
import otpGenerateReducer from "./slice/sendOtp";
import customerDetailsReducer from "./slice/customerDetails";
import addCustomerReducer from "./slice/addCustomer";
import allTransactionsReducer from "./slice/allTransactions";
import updateCustomerReducer from "./slice/editProfile";
import earnedPointsReducer from "./slice/earnedPoints";
import uploadBillReducer from "./slice/uploadBill";
import createUserGroupReducer from "./slice/createUserGroup";
import joinMemberSlice from "./slice/joinMember";
import getUserGroupReducer from "./slice/getUserGroup";
import checkCustomerReducer from "./slice/checkCustomer";
import isTransferableReducer from "./slice/points-transfer/isTransferable";
import pointsTransferReducer from "./slice/points-transfer/pointsTransfer";
import mallsReducer from "./slice/malls/malls";
import faqsReducer from "./slice/faqs/faqs";
import termsOfUseReducer from "./slice/termsOfUse/termsOfUse";
import offersReducer from "./slice/offers/offers";
import customerReducer from "./slice/userId-customer/customer";
import feedbackReducer from "./slice/feedback/feedback";
import contactUsReducer from "./slice/contact-us/contactUs";
import rewardsReducer from "./slice/offers/rewards";
import issueRewardReducer from "./slice/offers/issueRewards";
import redemptionAllowanceReducer from "./slice/offers/redemptionAllowance";
import activeRewardReducer from "./slice/offers/activeRewards";
import expiredRewardReducer from "./slice/offers/expired";
import categoryListReducer from "./slice/category-list/categoryList";
import deleteCustomerReducer from "./slice/deleteCustomer";
import getNewIdReducer from "./slice/upload-bills/getNewId";
import uploadBillsReducer from "./slice/upload-bills/uploadBill";
import customerLookupDetailsSlice from "./slice/customerLookup";
import localizesReducer from "./slice/localizes";
// Combine reducers
const combinedReducer = combineReducers({
  user: userReducer,
  otpGenerateData: otpGenerateReducer,
  customerDetails: customerDetailsReducer,
  addCustomer: addCustomerReducer,
  allTransactions: allTransactionsReducer,
  updateCustomer: updateCustomerReducer,
  earnedPoints: earnedPointsReducer,
  uploadBill: uploadBillReducer,
  userGroup: createUserGroupReducer,
  joinMember: joinMemberSlice,
  getUserGroup: getUserGroupReducer,
  checkCustomer: checkCustomerReducer,
  isTransferable: isTransferableReducer,
  pointsTransfer: pointsTransferReducer,
  malls: mallsReducer,
  faqs: faqsReducer,
  termsOfUse: termsOfUseReducer,
  offers: offersReducer,
  customer: customerReducer,
  feedback: feedbackReducer,
  contactUs: contactUsReducer,
  rewards: rewardsReducer,
  issueReward: issueRewardReducer,
  redemptionAllowance: redemptionAllowanceReducer,
  activeReward: activeRewardReducer,
  expiredReward: expiredRewardReducer,
  categoryList: categoryListReducer,
  deleteCustomer: deleteCustomerReducer,
  customerLookup: customerLookupDetailsSlice,
  getNewId : getNewIdReducer,
  uploadBills : uploadBillsReducer,
  localizes: localizesReducer,

});
// Define a reset action

const rootReducer = (state, action) => {
  if (action.type === "RESET") {
    //We are calling this RESET, but call what you like!
    state = {};
  }
  return combinedReducer(state, action);
};

// const store = configureStore({
//   reducer: {
//     user: userReducer,
//     otpGenerateData: otpGenerateReducer,
//     customerDetails: customerDetailsReducer,
//     addCustomer: addCustomerReducer,
//     allTransactions: allTransactionsReducer,
//     updateCustomer: updateCustomerReducer,
//     earnedPoints: earnedPointsReducer,
//     uploadBill: uploadBillReducer,
//   },
//   //   middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
// });
const store = configureStore({
  reducer: rootReducer,
});

export default store;
